<div class="equipment__container">
  <evc-platform
    class="equipment__platform"
    [inputAppIdentification]="appIdentification()"
    [inputHelpMenu]="helpMenu()"
    [i18nAppService]="i18nService">
    @if (ready()) {
      <main class="equipment__container">
        <router-outlet />
      </main>
    }
  </evc-platform>
</div>
